import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ApiParameter, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { Draft } from "immer";

export interface GetBackOrderApiParameter extends ApiParameter, HasPagingParameters {
    sku?: string;
    orderNumber?: string;
    fromDate?: string;
    toDate?: string;
}

export interface BackOrderListState {
    getBackOrderApiParameter: GetBackOrderApiParameter;
    isFilterOpen: boolean;
}

const initialState: BackOrderListState = {
    isFilterOpen: true,
    getBackOrderApiParameter: {
        sort: "orderDate DESC",
    },
};

const reducer = {
    "Pages/BackOrderListPage/ClearParameter": (draft: Draft<BackOrderListState>) => {
        draft.getBackOrderApiParameter = {
            ...initialState.getBackOrderApiParameter,
            pageSize: draft.getBackOrderApiParameter.pageSize,
        };
    },
    "Pages/BackOrderListPage/ToggleFiltersOpen": (draft: Draft<BackOrderListState>) => {
        draft.isFilterOpen = !draft.isFilterOpen;
    },
    "Pages/BackOrderListPage/UpdateSearchFields": (
        draft: Draft<BackOrderListState>,
        action: {
            parameter: GetBackOrderApiParameter & UpdateSearchFieldsType;
        },
    ) => {
        const { type } = action.parameter;
        delete action.parameter.type;

        draft.getBackOrderApiParameter = { ...draft.getBackOrderApiParameter, ...action.parameter };

        for (const key in draft.getBackOrderApiParameter) {
            const value = (<any>draft.getBackOrderApiParameter)[key];

            // remove empty parameters
            if (value === "" || value === undefined) {
                delete (<any>draft.getBackOrderApiParameter)[key];
            }
        }

        for (const key in action.parameter) {
            // go back to page 1 if any other parameters changed
            if (
                draft.getBackOrderApiParameter.page &&
                draft.getBackOrderApiParameter.page > 1 &&
                key !== "page" &&
                key !== "pageSize"
            ) {
                draft.getBackOrderApiParameter.page = 1;
            }
        }
    },
};

const xBackOrderListState = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xBackOrderListState = xBackOrderListState;

export type xBackOrderListState = {
    xBackOrderListState: BackOrderListState;
};

type xBackOrderListStateReducers = {
};

export type xBackOrderListStateActions = Parameters<xBackOrderListStateReducers[keyof xBackOrderListStateReducers]>[1] | AnyAction;
